export const FETCH_NOTIFICATIONS = 'notification/fetchNotifications';
export const FETCH_NOTIFICATIONS_START = 'notification/fetchNotificationsStart';
export const FETCH_NOTIFICATIONS_COMPLETE = 'notification/fetchNotificationsComplete';
export const FETCH_NOTIFICATIONS_ERROR = 'notification/fetchNotificationsError';

export const MARK_NOTIFICATION_READ = 'notification/markNotificationRead';
export const MARK_NOTIFICATION_READ_START = 'notification/markNotificationReadStart';
export const MARK_NOTIFICATION_READ_COMPLETE = 'notification/markNotificationReadComplete';
export const MARK_NOTIFICATION_READ_ERROR = 'notification/markNotificationReadError';

export const MARK_ALL_NOTIFICATIONS_READ = 'notification/markAllNotificationsRead';
export const MARK_ALL_NOTIFICATIONS_READ_START = 'notification/markAllNotificationsReadStart';
export const MARK_ALL_NOTIFICATIONS_READ_COMPLETE = 'notification/markAllNotificationsReadComplete';
export const MARK_ALL_NOTIFICATIONS_READ_ERROR = 'notification/markAllNotificationsReadError';

export const FETCH_NOTIFICATION_COUNT = 'notification/fetchNotificationCount';
export const FETCH_NOTIFICATION_COUNT_START = 'notification/fetchNotificationCountStart';
export const FETCH_NOTIFICATION_COUNT_COMPLETE = 'notification/fetchNotificationCountComplete';
export const FETCH_NOTIFICATION_COUNT_ERROR = 'notification/fetchNotificationCountError';

export const fetchNotifications = (payload = {}) => ({
  type: FETCH_NOTIFICATIONS,
  payload,
});

export const markNotificationAsRead = (payload = {}) => ({
  type: MARK_NOTIFICATION_READ,
  payload,
});

export const markAllNotificationsAsRead = (payload = {}) => ({
  type: MARK_ALL_NOTIFICATIONS_READ,
  payload,
});

export const fetchNotificationCount = (payload = {}) => ({
  type: FETCH_NOTIFICATION_COUNT,
  payload,
});

